import { Component, Input, OnInit } from '@angular/core';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { Observable } from 'rxjs';
import { AppModel, TwoStrokeHeatExchangerHotWaterSystem } from '@ams/dumbledore';
import { DataPointsResult, SystemDevice } from '../../../interfaces/data-points';
import { getPumpOptions, getPumpType, systemsToPumpDevice, systemsToValveDevice } from '../../../utils/data-point-utils';
import { SchematicsService } from '../../../services/schematics.service';
import { PumpOption } from 'projects/customerportal/src/app/services/installation-configuration.service';
import { Installation } from '../../../interfaces/facilty';
import { map } from "rxjs/operators";
import { systemHasEnergyValve } from 'projects/dumbledore/src/schematic/util/system-properties-util';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { PumpStatusTileComponent } from '../../pump-status-tile/pump-status-tile.component';
import { ValveStatusTileComponent } from '../../valve-status-tile/valve-status-tile.component';
import { ForwardReturnChartTileComponent } from '../../charts/forward-return-chart-tile/forward-return-chart-tile.component';
import { ValveChartComponent } from '../../charts/valve-chart/valve-chart.component';
import { EnergyValveHeatAndFlowChartComponent } from '../../charts/energy-valve-heat-and-flow-chart/energy-valve-heat-and-flow-chart.component';
import { EnergyValveTemperatureChartComponent } from '../../charts/energy-valve-temperature-chart/energy-valve-temperature-chart.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-two-stroke-heat-exchanger-dashboard',
    templateUrl: './two-stroke-heat-exchanger-dashboard.component.html',
    styleUrls: ['./two-stroke-heat-exchanger-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    PumpStatusTileComponent,
    ValveStatusTileComponent,
    ForwardReturnChartTileComponent,
    ValveChartComponent,
    EnergyValveHeatAndFlowChartComponent,
    EnergyValveTemperatureChartComponent,
    TranslateModule,
    AsyncPipe
]
})
export class TwoStrokeHeatExchangerDashboardComponent implements OnInit {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  public pumpDevice$: Observable<SystemDevice | undefined>;
  public pumpType$: Observable<string>;
  public pumpOptions$: Observable<PumpOption[] | undefined>;
  public valveDevice$: Observable<SystemDevice | undefined>;
  public hasEnergyValve$: Observable<boolean | undefined>;
  private system$: Observable<TwoStrokeHeatExchangerHotWaterSystem>;

  constructor(private schematicsService: SchematicsService) {}

  ngOnInit(): void {
    this.system$ = this.schematic$.pipe(
      map((schematic) => {
        return schematic.systems.find((s) => s.hasId === this.application.id) as TwoStrokeHeatExchangerHotWaterSystem;
      })
    );

    this.pumpDevice$ = this.dataPoints$.pipe(systemsToPumpDevice(this.application.id));
    this.pumpType$ = getPumpType(this.schematic$, this.application.id);

    this.pumpOptions$ = getPumpOptions(this.pumpDevice$, this.schematicsService, this.application.id);

    this.valveDevice$ = this.dataPoints$.pipe(systemsToValveDevice(this.application.id));

    this.hasEnergyValve$ = this.system$.pipe(
      map((system) => {
        return systemHasEnergyValve(system?.systemInfo);
      })
    );
  }
}
